import { useQuery } from 'react-query';
import { GET } from './http-service';

export const Org = ({ journeyGuid, lngCode, useMock }) => {

  const baseApi = `${lngCode}/org`;

  return {
    useCustomerIdTypesQuery() {
      return useQuery(
        ['customer-id-type', journeyGuid, lngCode],
        () => getCustomerIdType(),
        { enabled: !!lngCode, staleTime: 1000 * 60 * 10 }
      );
    },
    useCustomerCancelationReasons() {
      return useQuery(
        ['customer-reasons', journeyGuid, lngCode],
        () => getCustomerCancelationReasons(),
        { enabled: !!lngCode }
      );
    },

  };

  function getCustomerIdType() {
    if (useMock) {
      return Promise.resolve(() => {
        return [...Array(3).keys()].map(x => {
          return { id: x, name: `Customer Id Type ${++x}`, isActive: true }
        })
      })
    }
    return GET(`${baseApi}/customeridtypes`);
  }
  function getCustomerCancelationReasons() {

    if (useMock) {
      return Promise.resolve(() => {
        return [...Array(3).keys()].map(x => {
          return { appointmentCancellationReasonId: ++x, name: `Appointment Cancellation Reason ${++x}`, isActive: true }
        })
      })
    }

    return GET(`${baseApi}/cancelationreasons`)
  }
}